import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal } from 'antd';
import { _new_room_window } from '../../../store/Action';
import Util from '../../../script/util';
import './JoinTalk.scss';

let randomPeople = 0;

class JoinTalk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  showModal = () => {
    randomPeople = Util.convertNum(Math.floor(Math.random() * 1000000));
    this.setState({
      visible: true,
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  //加入直播
  joinRoom = () => {
    const { ds } = this.props;
    if (ds && ds.roomid) {
      _new_room_window(
        {
          roomid: ds.roomid,
          roomname: ds.roomname,
        },
        this.props.history,
        () => {
          this.hideModal();
        },
        `2|${ds.uid}`
      );
    }
  };

  render() {
    const { ds } = this.props;
    return (
      <Modal
        open={this.state.visible}
        wrapClassName="iframe-body"
        centered={true}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="544px"
        zIndex="1002"
        height="344px"
      >
        <div className="talk-warp">
          <div className="avatar">
            {ds && <img src={Util.transImgUrl(ds.headPic, '100x100')} alt="" />}
          </div>
          <i
            onClick={(e) => this.setState({ visible: false })}
            className="close"
          ></i>
          {ds && (
            <p className="join-desc">
              我正在
              <span onClick={this.joinRoom} className="room-name">
                {ds.roomName}
              </span>
              直播间语聊中…
            </p>
          )}
          <div className="join" onClick={this.joinRoom}>
            立即加入
          </div>
          <div className="foot">
            <i className="voice"></i>
            <span className="count">{randomPeople}</span>
            <span className="tail">人正在语聊室找朋友</span>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(JoinTalk, { withRef: true });
